<template>
  <div class="while-loading">
    数据加载中...
  </div>
</template>

<script>
export default {
  name: 'WhileLoading'
}
</script>

<style scoped>
.while-loading {
    text-align: center;
    font-size: medium;
}
</style>


// WEBPACK FOOTER //
// src/commonReform/WhileLoading.vue